import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import socket from "socket.io-client";
import AuthService from "./service/auth";
import TweetService from "./service/tweet";
import { BrowserRouter } from "react-router-dom";
import {
  AuthProvider,
  fetchToken,
  fetchCsrfToken,
} from "./context/AuthContext";
import { AuthErrorEventBus } from "./context/AuthContext";
import HttpClient from "./network/http";
import Socket from "./network/socket";

const baseURL = process.env.REACT_APP_BASE_URL;
const authErrorEventBus = new AuthErrorEventBus();
const httpClient = new HttpClient(baseURL, authErrorEventBus, () =>
  fetchCsrfToken(),
);
const authService = new AuthService(httpClient);
const socketClient = new Socket(baseURL, () => fetchToken()); // callback함수 호출 -> 최근 토큰 가져오기
// socket은 브라우저처럼 자동으로 쿠키 가져오지 않음 -> 수동적으로 업데이트 해줄 부분
// memory상에 토큰 보관해서 이 안에 있는 토큰을 소켓에 보내기
// 메모리에 저장하는 것은 보안에 안전함
const tweetService = new TweetService(httpClient, socketClient); // Dependency injection

const socketIO = socket(baseURL); //?
socketIO.on("connect_error", (err) => {
  console.log("socket error :", err);
});
socketIO.on("tweets", (tweet) => {
  console.log(tweet);
});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider
        authService={authService}
        authErrorEventBus={authErrorEventBus}
      >
        <App tweetService={tweetService} />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById("root"),
);
